import { createUseStyles } from 'react-jss';
const useActionButtonStyles = createUseStyles((theme) => ({
    container: {
        border: '1px solid rgba(225, 228, 234, 1)',
        borderRadius: '16px',
        backgroundColor: theme.colors.common.white,
        boxShadow: '0px 1px 2px 0px rgba(10, 13, 20, 0.03)',
        width: ({ fullWidth }) => (fullWidth ? '100%' : 'fit-content'),
        overflow: 'hidden'
    }
}));
export default useActionButtonStyles;
